import { render, staticRenderFns } from "./ColumnNotImplementedMessage.vue?vue&type=template&id=a88c541c"
import script from "./ColumnNotImplementedMessage.vue?vue&type=script&lang=js"
export * from "./ColumnNotImplementedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports